import { Injectable } from '@angular/core';

/**
 * Drawing policy for draft mode.
 * Accepts pen, touch, and mouse pointer events.
 */
@Injectable({ providedIn: 'root' })
export class DraftPolicyService {
  shouldDraw(event: PointerEvent): boolean {
    return (
      event.pointerType === 'pen' ||
      event.pointerType === 'touch' ||
      event.pointerType === 'mouse'
    );
  }
}
